var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "opens in new web page") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "100.2---BBL---Day-2---Loan-summary---Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "100.2e---BBL---D---Loan-summary",
    transform: "translate(-453.000000, -546.000000)",
    fill: "#5e10b1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-col",
    transform: "translate(212.000000, 134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(0.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/Base-Icons/Action/Link-out",
    transform: "translate(242.500000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.400000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rectangle",
    transform: "translate(0.000000, 5.315127)",
    fillRule: "nonzero",
    stroke: "#5e10b1",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.077,0.725459627 L6.077,2.53945963 L1.80177515,2.54037095 L1.80177515,16.3329635 L15.4952663,16.3329635 L15.495,12.4274596 L17.297,12.4274596 L17.2970414,16.6959265 C17.2970414,17.4977621 16.6516957,18.1477784 15.8556213,18.1477784 L1.44142012,18.1477784 C0.645345769,18.1477784 0,17.4977621 0,16.6959265 L0,2.17740799 C0,1.37557235 0.645345769,0.725556139 1.44142012,0.725556139 L6.077,0.725459627 Z",
    id: "download-stmt"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.197256,2.55248289 C14.8621084,2.54539453 15.3952738,3.0785599 15.3881141,3.74341235 L15.301931,11.6681807 L18.0911049,8.88100119 C18.5299536,8.4427842 19.2129968,8.4020832 19.6814578,8.76383865 L19.7956162,8.86444336 C20.2252241,9.29340591 20.2513803,9.97586562 19.8791752,10.4521247 L19.7772857,10.5666335 L14.960674,15.3804006 L14.9145335,15.4336573 C14.6932914,15.654583 14.4128184,15.7743125 14.1286439,15.7940455 L13.980662,15.795639 C13.7441492,15.784292 13.5117033,15.7034315 13.3165112,15.5527001 L13.2023528,15.4520954 L13.156145,15.3998331 L8.44330848,10.6886864 L8.34386184,10.5763458 C8.01199843,10.1470228 8.018679,9.53718376 8.36019832,9.10091054 L8.46163896,8.98649624 C8.90216564,8.54660182 9.58533793,8.50577179 10.0538088,8.86751731 L10.1661889,8.96634271 L12.8943003,11.6929042 L12.9804704,3.76933968 C12.9876301,3.10448723 13.5324035,2.5597138 14.197256,2.55248289 Z",
    id: "Path",
    transform: "translate(14.119461, 9.174061) rotate(-135.000000) translate(-14.119461, -9.174061) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.8cde2b35d1bd6ca516b30161c6880f46.svg";
export { ForwardRef as ReactComponent };